import comp from "./QuestionDetailsSideBar";
export default comp;
